import DOMPurify from 'dompurify';

const CONFIG = {
  ALLOWED_TAGS: ['p', 'strong', 'u', 'ul', 'ol', 'li', 'a', 'br'],
  ALLOWED_ATTR: ['href', 'target'],
};

// Listing-card variant: no <a> tags (card is already clickable); link text is preserved by DOMPurify's default KEEP_CONTENT behavior.
const SUMMARY_CONFIG = {
  ALLOWED_TAGS: ['p', 'strong', 'u', 'ul', 'ol', 'li', 'br'],
  ALLOWED_ATTR: [],
};

// Replaces the ™ symbol (and its HTML entity forms) with a styled superscript
// element. Applied after DOMPurify so the injected <sup> is not stripped.
function replaceTm(html) {
  return html.replace(/™|&trade;|&#8482;|&#x2122;/gi, '<sup class="tm-symbol">TM</sup>');
}

export function sanitizeHtml(html) {
  return replaceTm(DOMPurify.sanitize(html || '', CONFIG));
}

export function summaryHtml(html) {
  return replaceTm(DOMPurify.sanitize(html || '', SUMMARY_CONFIG));
}

export function summaryText(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, CONFIG)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function bioToHtml(bio) {
  if (!bio) return '';
  return sanitizeHtml(bio.replace(/\n/g, '<br>'));
}
